import * as Icon from '@/ui/Icon';
import { IUser } from '@/types';

import NavTabs, { LinkTab } from '../NavTabs';

const UserNavTabs: React.FC<{ user?: IUser; currentUser?: IUser }> = ({ user, currentUser }) => {
  const isCurrentUser = currentUser?.id === user?.id;

  const baseUserPath = `/${user?.username}`;
  const repositoriesPath = baseUserPath;
  // const organizationsPath = `${baseUserPath}/`;
  // const settingsPath = `${baseUserPath}/`;
  const organizationsPath = `/settings/organizations`;
  const settingsPath = `/settings/profile`;

  const canSeeOrganizations = user && isCurrentUser;
  const canSeeSettings = user && isCurrentUser;

  return (
    <NavTabs>
      <LinkTab href={repositoriesPath}>
        <Icon.Book />
        <span>Repositories</span>
      </LinkTab>
      {canSeeOrganizations && (
        <LinkTab href={organizationsPath}>
          <Icon.Building />
          <span>Organizations</span>
        </LinkTab>
      )}
      {canSeeSettings && (
        <LinkTab href={settingsPath}>
          <Icon.Cog />
          <span>Settings</span>
        </LinkTab>
      )}
    </NavTabs>
  );
};

export default UserNavTabs;
